import React from 'react';
import { Box, Container, Typography, Grid, Card, Avatar, Chip, Button } from '@mui/material';
import { 
  School as SchoolIcon,
  Language as LanguageIcon,
  Public as PublicIcon,
  Star as StarIcon
} from '@mui/icons-material';
import personImage from '../assets/images/person.webp';
import team1 from '../assets/images/team1.webp';
import team2 from '../assets/images/team2.webp';
import team3 from '../assets/images/team3.webp';
import team4 from '../assets/images/team4.webp';

const achievements = [
  { icon: <SchoolIcon />, text: "Master's in International Chinese Teaching" },
  { icon: <LanguageIcon />, text: "10+ Years International Experience" },
  { icon: <PublicIcon />, text: "Multi-Country Teaching Background" },
  { icon: <StarIcon />, text: "Award-Winning Educator" }
];

const teamStats = [
  { number: "7+", label: "Years Experience" },
  { number: "4000+", label: "Teaching Hours" },
  { number: "5+", label: "Business Chinese Years" },
  { number: "3000+", label: "Business Teaching Hours" }
];

function Team() {
  return (
    <Box
      sx={{
        pt: {xs: 6, md: 12},
        bgcolor: 'white',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
        <Container maxWidth="xl" sx={{ px: { xs: 2 } }}>
            {/* 标题区域 */}
            <Box sx={{ textAlign: 'center', mb: 10, position: 'relative' }}>
            {/* 装饰性背景元素 */}
            <Box
                sx={{
                position: 'absolute',
                top: {'xs': '20%', md: '50%'},
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: {'xs': '150px', md: '200px'},
                height: {'xs': '150px', md: '200px'},
                background: 'linear-gradient(135deg, rgba(7, 40, 75, 0.03) 0%, rgba(159, 33, 34, 0.08) 100%)',
                borderRadius: '50%',
                zIndex: 1
                }}
            />
            
            <Box sx={{ position: 'relative', zIndex: 2 }}>
                
                {/* 主标题 */}
                <Typography
                variant="h2"
                component="h2"
                sx={{
                    fontFamily: 'serif',
                    fontWeight: 700,
                    color: '#07284b',
                    mb: 4,
                    fontSize: { xs: '2.5rem', md: '3.5rem' },
                    lineHeight: 1.2,
                    position: 'relative',
                }}
                >
                Founder & Teaching Team
                </Typography>
                
                {/* 描述文字 */}
                <Typography
                variant="h6"
                sx={{
                    color: '#b97576',
                    maxWidth: 800,
                    mx: 'auto',
                    fontSize: '1.2rem',
                    lineHeight: 1.6,
                    fontWeight: 400
                }}
                >
                Distinguished educators with international credentials and extensive experience 
                in Chinese language instruction and cross-cultural communication.
                </Typography>
            </Box>
            
            </Box>

            {/* 创始人介绍 */}
            <Box sx={{ mb: 10 }}>
            <Grid container spacing={6} alignItems="center">
                {/* 左侧头像和基本信息 */}
                <Grid item xs={12} md={4}>
                <Box sx={{ textAlign: 'center' }}>
                    <Avatar
                    src={personImage}
                    alt="Chihui Cao"
                    sx={{
                        width: 200,
                        height: 200,
                        mx: 'auto',
                        mb: 3,
                        border: '4px solid #07284b',
                        boxShadow: '0 8px 32px rgba(7, 40, 75, 0.2)'
                    }}
                    />
                    
                    <Typography
                    variant="h4"
                    sx={{
                        fontWeight: 700,
                        color: '#07284b',
                        mb: 1
                    }}
                    >
                    Chihui Cao
                    </Typography>
                    
                    <Typography
                    variant="h6"
                    sx={{
                        color: '#9f2122',
                        mb: 3,
                        fontWeight: 500
                    }}
                    >
                    Founder & Chief Instructor
                    </Typography>

                    {/* 成就标签 */}
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'center' }}>
                    {achievements.map((achievement, index) => (
                        <Chip
                        key={index}
                        icon={achievement.icon}
                        label={achievement.text}
                        sx={{
                            bgcolor: '#f8f9fa',
                            color: '#07284b',
                            border: '1px solid #e9ecef',
                            '& .MuiChip-icon': {
                            color: '#9f2122'
                            }
                        }}
                        />
                    ))}
                    </Box>
                </Box>
                </Grid>

                {/* 右侧详细描述 */}
                <Grid item xs={12} md={8}>
                <Box sx={{ pl: { md: 4 } }}>
                    <Typography
                    variant="body1"
                    sx={{
                        color: '#34495e',
                        fontSize: '1.15rem',
                        lineHeight: 1.8,
                        mb: 3
                    }}
                    >
                    Ms. Chihui Cao is the Founder and Chief Mentor of CHIHUI Mandarin Hub, with over a decade of experience in international Chinese education and cross-cultural communication. She holds a Master's in Teaching Chinese as a Foreign Language from the National Institute of Education (NIE), NTU, a Master's in Broadcasting & Television Arts from Shanghai University, and a Bachelor's in Chinese Language and Literature.
                    </Typography>

                    <Typography
                    variant="body1"
                    sx={{
                        color: '#34495e',
                        fontSize: '1.15rem',
                        lineHeight: 1.8,
                        mb: 3
                    }}
                    >
                    Before founding CHIHUI Mandarin Hub, Ms. Cao taught at schools and institutions in the U.S., China, and Singapore. She served as a Chinese teacher at the Confucius Institute, University of Kentucky, where she organized cultural workshops and speech competitions. As a lecturer at Yangtze University, she taught broadcasting and television arts, mentored research projects, and earned multiple awards for excellence in student supervision.
                    </Typography>

                    <Typography
                    variant="body1"
                    sx={{
                        color: '#34495e',
                        fontSize: '1.15rem',
                        lineHeight: 1.8,
                        mb: 4
                    }}
                    >
                    In Singapore, Ms. Cao led the Chinese department at ASE Education Group, designing international K-12 curricula, developing IB/IGCSE resources, and training teachers. She is highly experienced in IB, AP, and A-Level programs and is widely respected by students and parents alike.
                    </Typography>
                    {/* 引用 */}
                    <Box
                    sx={{
                        p: 3,
                        bgcolor: '#f8f9fa',
                        borderRadius: 2,
                        borderLeft: '4px solid #9f2122',
                        fontStyle: 'italic',
                        position: 'relative'
                    }}
                    >
                    <Typography
                        variant="h6"
                        sx={{
                        color: '#07284b',
                        fontSize: '1.2rem',
                        lineHeight: 1.6,
                        mb: 1
                        }}
                    >
                        "Language changes the world. Learning Chinese is a journey to explore culture and connect with the world."
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                        color: '#6c757d',
                        textAlign: 'right'
                        }}
                    >
                        — Chihui Cao, Founder
                    </Typography>
                    </Box>
                </Box>
                </Grid>
                </Grid>
             </Box>

             {/* 团队统计 */}
             <Box sx={{ mb: 12 }}>
               <Typography
                 variant="h3"
                 component="h3"
                 sx={{
                   fontFamily: 'serif',
                   fontWeight: 700,
                   color: '#07284b',
                   mb: 4,
                   textAlign: 'center',
                   fontSize: { xs: '2rem', md: '2.5rem' }
                 }}
               >
                 Our Achievements
               </Typography>
               

                {/* 团队介绍文字 */}
                <Typography
                    variant="body1"
                    sx={{
                    fontSize: '1.1rem',
                    lineHeight: 1.8,
                    textAlign: 'center',
                    maxWidth: 900,
                    mx: 'auto',
                    mb: 4
                    }}
                >
                    Our team consists of highly qualified instructors who are all native Chinese speakers with bilingual or trilingual proficiency. 
                </Typography>
               <Grid container spacing={4} sx={{ mb: 6 }}>
                 {teamStats.map((stat, index) => (
                   <Grid item xs={6} md={3} key={index}>
                     <Card
                       sx={{
                         textAlign: 'center',
                         p: 3,
                         borderRadius: 3,
                         boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                         border: '1px solid #e9ecef',
                         transition: 'all 0.3s ease',
                         '&:hover': {
                           transform: 'translateY(-4px)',
                           boxShadow: '0 8px 30px rgba(0,0,0,0.12)'
                         }
                       }}
                     >
                       <Typography
                         variant="h3"
                         sx={{
                           fontWeight: 700,
                           color: '#9f2122',
                           mb: 1
                         }}
                       >
                         {stat.number}
                       </Typography>
                       <Typography
                         variant="body1"
                         sx={{
                           color: '#34495e',
                           fontWeight: 500
                         }}
                       >
                         {stat.label}
                       </Typography>
                     </Card>
                   </Grid>
                 ))}
               </Grid>
             </Box>

         </Container>
      
        {/* 教师团队介绍 */}
        <Box 
            sx={{
            py: 8,
            px: { xs: 2, md: 4 },
            background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
            position: 'relative',
            overflow: 'hidden',
            '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'radial-gradient(circle at 30% 20%, rgba(159, 33, 34, 0.1) 0%, transparent 50%), radial-gradient(circle at 70% 80%, rgba(7, 40, 75, 0.1) 0%, transparent 50%)',
                zIndex: 1
            }
            }}
        >
            <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
            

            {/* 教师卡片网格 */}
            <Grid container spacing={4} sx={{ mb: 8, pt: 4 }}>
                                 {[
                 {
                     name: 'William Zhang',
                     title: 'Senior Chinese Instructor',
                     experience: '8+ Years',
                     specialization: 'HSK & Business Chinese',
                     avatar: team1
                 },
                 {
                     name: 'Tina Zheng',
                     title: 'Business Chinese Specialist',
                     experience: '6+ Years',
                     specialization: 'International Programs',
                     avatar: team2
                 },
                 {
                     name: 'Joyce Chen',
                     title: 'Youth Program Coordinator',
                     experience: '7+ Years',
                     specialization: 'Cultural Immersion',
                     avatar: team3
                 },
                 {
                     name: 'Arlenan',
                     title: 'Cultural Immersion Program Director',
                     experience: '6+ Years',
                     specialization: 'Cultural Immersion Program ',
                     avatar: team4
                 }
                 ].map((teacher, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                    <Card
                    sx={{
                        textAlign: 'center',
                        p: 3,
                        borderRadius: 3,
                        background: 'rgba(255, 255, 255, 0.05)',
                        backdropFilter: 'blur(10px)',
                        border: '1px solid rgba(255, 255, 255, 0.1)',
                        transition: 'all 0.3s ease',
                        height: '100%',
                        '&:hover': {
                        transform: 'translateY(-8px)',
                        background: 'rgba(255, 255, 255, 0.08)',
                        border: '1px solid rgba(159, 33, 34, 0.3)',
                        boxShadow: '0 12px 40px rgba(159, 33, 34, 0.2)'
                        }
                    }}
                    >
                    {/* 头像 */}
                     <Avatar
                         src={teacher.avatar}
                         alt={teacher.name}
                         sx={{
                         width: 160,
                         height: 160,
                         mx: 'auto',
                         mb: 2,
                         border: '3px solid rgba(255, 255, 255, 0.2)'
                         }}
                     />
                    
                    {/* 姓名 */}
                    <Typography
                        variant="h6"
                        sx={{
                        color: 'white',
                        fontWeight: 700,
                        mb: 1,
                        fontSize: '1.1rem'
                        }}
                    >
                        {teacher.name}
                    </Typography>
                    
                    {/* 职位 */}
                    <Typography
                        variant="body2"
                        sx={{
                        color: '#9f2122',
                        fontWeight: 600,
                        mb: 2,
                        fontSize: '0.9rem'
                        }}
                    >
                        {teacher.title}
                    </Typography>
                    
                    {/* 经验 */}
                    <Typography
                        variant="body2"
                        sx={{
                        color: 'rgba(255, 255, 255, 0.7)',
                        mb: 1,
                        fontSize: '0.85rem'
                        }}
                    >
                        {teacher.experience} Experience
                    </Typography>
                    
                    {/* 专业领域 */}
                    <Typography
                        variant="body2"
                        sx={{
                        color: 'rgba(255, 255, 255, 0.6)',
                        fontSize: '0.8rem',
                        lineHeight: 1.4
                        }}
                    >
                        {teacher.specialization}
                    </Typography>
                    </Card>
                </Grid>
                ))}
            </Grid>
            <Typography
                variant="h6"
                sx={{
                color: 'rgba(255, 255, 255, 0.8)',
                textAlign: 'center',
                fontSize: '1.1rem',
                maxWidth: 600,
                mx: 'auto'
                }}
            >
                Meet our dedicated team of experienced Chinese language educators
            </Typography>


            <Typography
                variant="body1"
                sx={{
                color: 'rgba(255, 255, 255, 0.8)',
                fontSize: '1.1rem',
                lineHeight: 1.8,
                textAlign: 'center',
                maxWidth: 900,
                mx: 'auto',
                mb: 6
                }}
            >
                We advocate for personalized learning paths, tailoring study plans according to 
                individual learning goals and proficiency levels, ensuring every learner can 
                progress efficiently and enjoyably.
            </Typography>

            {/* 行动号召按钮 */}
            <Box sx={{ textAlign: 'center', mt: 10 }}>
                <Button
                    variant="contained"
                    size="large"
                    sx={{
                        bgcolor: '#9f2122',
                        color: 'white',
                        px: { xs: 2, md: 8 },
                        py: 3,
                        fontSize: '1.3rem',
                        fontWeight: 700,
                        borderRadius: '50px',
                        textTransform: 'none',
                        boxShadow: '0 8px 32px rgba(159, 33, 34, 0.4)',
                        border: '2px solid rgba(255, 255, 255, 0.2)',
                        minWidth: '300px',
                        position: 'relative',
                        overflow: 'hidden',
                        '&:hover': {
                            bgcolor: '#8a1e1f',
                            transform: 'translateY(-4px)',
                            boxShadow: '0 12px 40px rgba(159, 33, 34, 0.5)',
                            '&::before': {
                                transform: 'scale(1.1)',
                                opacity: 0.1
                            }
                        },
                        '&::before': {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: 'linear-gradient(45deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)',
                            borderRadius: '50px',
                            transition: 'all 0.3s ease',
                            zIndex: 1
                        },
                        '& > *': {
                            position: 'relative',
                            zIndex: 2
                        },
                        transition: 'all 0.3s ease'
                    }}
                >
                    <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
                        Start Your Chinese Learning Journey
                    </Box>
                    <Box component="span" sx={{ display: { xs: 'inline', sm: 'none' } }}>
                        Start Your Journey
                    </Box>
                </Button>
                
                <Typography
                    variant="body2"
                    sx={{
                        color: 'rgba(255, 255, 255, 0.7)',
                        mt: 2,
                        fontSize: '0.9rem',
                        fontStyle: 'italic'
                    }}
                >
                    Choose Chihui Mandarin Hub and let language become your bridge to the world
                </Typography>
            </Box>
            </Container>
        </Box>
    </Box>
  );
}

export default Team;
